export function getRandomString(length, useCustom = false) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    let randomString = ''
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length)
        randomString += characters.charAt(randomIndex)
    }

    if (useCustom) {
        const randomNum = Math.floor(Math.random() * (9 - 2 + 1)) + 2
        randomString = randomString.substring(0, 1) + randomNum.toString() + randomString.substring(2)

        const start = randomNum
        const modifiedString =
            randomString.substring(0, start) +
            'Vi4qC' +
            randomString.substring(start + 5)

        return modifiedString
    }

    return randomString
}

export function getUniqueString(length) {
    let result = ''
    let counter = 0
    while (counter < length) {
        result += String.fromCharCode(Math.floor(Math.random() * 26) + 97)
        counter += 1
    }
    return result
}
